import { type LinksFunction, Outlet } from "react-router";

import { SidePattern } from "./ui/side-pattern";
import styleSheet from "./ui/tailwind.css?url";

export const links: LinksFunction = () =>
  [{ rel: "stylesheet", href: styleSheet as string }].filter(Boolean);

export default function AuthLayout() {
  return (
    <div className="relative container grid h-screen items-center justify-center lg:max-w-none lg:grid-cols-[1fr_550px_1fr] lg:px-0">
      <SidePattern />

      <div className="mx-auto w-full max-w-[350px]">
        <Outlet />
      </div>

      <SidePattern isReversed />
    </div>
  );
}
